import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Notification {

  public description: string;
  public type: string;
  public notificationId: number;
  public id: number;
  public status: string;
}
